import { GetChinaAddressDataTotalApi } from "@/api/index";

const state = {
  ChinaAddressDataTotal: []
};

const actions = {
  async getChinaAddressData({ state, commit }) {
    if (state.ChinaAddressDataTotal.length == 0) {
      let res = await GetChinaAddressDataTotalApi();
      if (res.status == "1") {
        commit("setAddressData", JSON.parse(res.data));
      }
    }
  }
};

const mutations = {
  setAddressData(state, data) {
    state.ChinaAddressDataTotal = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
